import { Helper } from './../../shared/helper';
import { BulkEditComponent } from './../bulk-edit/bulk-edit.component';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { FlightService } from '../flight.service';
import { IFlight } from '../flight';
import { NgbModal, NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { FlightComponent } from '../single/flight.component';
import { environment } from '../../../environments/environment';
import { LocationService } from '../../locations/location.service';
import { ILocation } from '../../locations/location';
import { CreateTicketComponent } from '../../tickets/create/create-ticket.component';
import { Router } from '../../../../node_modules/@angular/router';
import { FlightDetailsComponent } from '../details/flight-details.component';


@Component({
  templateUrl: './flights.component.html',
  styleUrls: ['./flights.component.css']
})
export class FlightsComponent implements OnInit {
  errorMessage: any;
  flights: IFlight[];
  locations: ILocation[];
  loaded = false;
  paging = {
    itemsPerPage: environment.itemsPerPage,
    total: 0,
    currentPage: 1
  };
  flightsForm: FormGroup;
  filterProps = {};
  hoveredDate: NgbDateStruct;
  fromDate: NgbDateStruct;
  toDate: NgbDateStruct;
  rangePicker = false;
  _WEEKDAYS = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ];
  selectedFlights = [];
  selectAllM: boolean;

  constructor(
    private _flightService: FlightService,
    private _modalService: NgbModal,
    private locationService: LocationService,
    private fb: FormBuilder,
    private calendar: NgbCalendar,
    private helper: Helper,
    private router: Router
  ) {
    this.locationService.getLocations({}).subscribe(
      res => {
        this.locations = res.body;
      },
      error => {}
    );
  }

  ngOnInit(): void {
    this.initFilterForm();
    this.filterTable();
  }

  private initFilterForm() {
    this.flightsForm = this.fb.group({
      flightDateTimeFrom: [this.calendar.getToday()],
      flightDateTimeTo: [
        this.calendar.getNext(this.calendar.getToday(), 'd', 91)
      ],
      flightNumber: [''],
      seats_available: [''],
      departure: [''],
      destination: ['']
    });
  }

  orderList(e: any) {
    this.helper.clearEmptyFormFilds(this.flightsForm.value);
    const orderStr = this.helper.getOrderStr(e);
    if (orderStr) {
      this.getPage(this.paging.currentPage, this.flightsForm.value, orderStr);
    }
  }

  getPage(page: number, filterProps: any = {}, orderStr?: string) {
    this.loaded = false;
    let params = { itemsPerPage: this.paging.itemsPerPage, page: page };
    params = Object.assign(params, filterProps);
    this._flightService.getFlights(params, orderStr).subscribe(res => {
      this.paging.total = Number(res.headers.get('X-total-count'));
      this.paging.currentPage = page;
      this.flights = res.body;
      this.flights.map(fl => {
        if (this.selectedFlights.find(sfl => sfl.id === fl.id)) {
          fl.selected = true;
        }
      });
      this.loaded = true;
    }, error => (this.errorMessage = <any>error));
  }

  addFlight() {
    this.registerModal('add');
  }

  editFlight(flight: IFlight) {
    this.registerModal('edit', flight);
  }

  deleteFlight(flight: IFlight, deletePermision?: boolean): void {
    if (!deletePermision) {
      if (confirm(`Are you sure to delete flight ${flight.flightNumber}?`)) {
        deletePermision = true;
      }
    }
    if (deletePermision) {
      this._flightService.deleteFlight(flight.id).subscribe(val => {
        this.flights.splice(this.flights.indexOf(flight), 1);
        console.log('Deleted flight', flight.id);
      }, error => (this.errorMessage = <any>error));
    }
  }

  viewFlightDetails(flight: IFlight) {
    const modalRef = this._modalService.open(FlightDetailsComponent, {
      size: 'lg',
      backdrop: 'static'
    });
    (<FlightDetailsComponent>modalRef.componentInstance).setFlight(flight);
  }

  registerModal(action: string, flight?: IFlight) {
    const modalRef = this._modalService.open(FlightComponent, {
      size: 'lg',
      backdrop: 'static'
      // beforeDismiss: () => confirm(`Are you sure to close form?`)
    });
    modalRef.result.then(
      res => {
        this.filterTable();
      },
      reason => {}
    );
    if (action === 'edit') {
      (<FlightComponent>modalRef.componentInstance).patchForm(flight);
    }
  }

  selectAll(e: any) {
    if (!this.selectAllM) {
      this.flights.map(fl => {
        fl.selected = true;
        this.selectFlight(fl);
      });
    } else {
      this.flights.map(fl => {
        fl.selected = false;
        this.selectFlight(fl);
      });
    }
  }

  bulkEdit(flights: IFlight[]) {
    const modalRef = this._modalService.open(BulkEditComponent, {
      size: 'lg',
      backdrop: 'static'
      // beforeDismiss: () => confirm(`Are you sure to close form?`)
    });
    modalRef.result.then(
      res => {
        this.filterTable();
      },
      reason => {}
    );
    (<BulkEditComponent>modalRef.componentInstance).flights = flights;
  }

  selectFlight(flight: IFlight, tagName = 'TD') {
    if (tagName === 'TD' || tagName === 'INPUT') {
      if (!flight.selected) {
        this.selectedFlights.pushIfNotSimilar(flight, 'id');
        flight.selected = true;
      } else {
        this.selectedFlights.forEach((fl, i) => {
          if (fl.id === flight.id) {
            this.selectedFlights.splice(i, 1);
            flight.selected = false;
          }
        });
      }
    }
  }

  bulkAction(e: any) {
    const action = e.target.value;
    e.target.value = '';
    if (this.selectedFlights.length < 2 && action) {
      alert('Please select at least 2 flights');
      return;
    }
    if (action === 'edit') {
      this.bulkEdit(this.selectedFlights);
    } else if (action === 'delete') {
      if (
        confirm(
          `Are you sure you want to delete ${
            this.selectedFlights.length
          } flights?`
        )
      ) {
        this.selectedFlights.forEach(flight => {
          this.deleteFlight(flight, true);
        });
      }
    }
    this.clearSelectedFlights();
  }

  clearSelectedFlights() {
    this.selectedFlights = [];
    this.flights.map(fl => {
      fl.selected = false;
    });
    this.selectAllM = false;
  }

  createTickets() {
    console.log(this.selectedFlights);
    const modalRef = this._modalService.open(CreateTicketComponent, {
      size: 'lg',
      backdrop: 'static'
      // beforeDismiss: () => confirm(`Are you sure to close form?`)
    });
    modalRef.result.then(res => {}, reason => {});
    (<CreateTicketComponent>modalRef.componentInstance).initFirstStepForm(
      this.selectedFlights
    );
  }

  filterTable(): void {
    const formValue = this.helper.clearEmptyFormFilds(this.flightsForm.value);
    const FV = this.helper.setPrefix(
      [
        { name: 'departure', pre: 'locations/' },
        { name: 'destination', pre: 'locations/' }
      ],
      formValue
    );
    this.getPage(1, FV, '?order[flightDateTime]=ASC');
  }

  loadTickets(flight: IFlight) {
    this.router.navigate(['/tickets'], {
      queryParams: {
        flight_id: flight.id
      }
    });
  }

  clear() {
    this.initFilterForm();
  }

  exportTickets(flight: IFlight) {
    window.open(environment.exportUrl + '?fid=' + flight.id);
  }
}



// WEBPACK FOOTER //
// ./src/app/flights/list/flights.component.ts